import { render, staticRenderFns } from "./InfoPubCoopNew.vue?vue&type=template&id=cd8cdf7e&scoped=true"
import script from "./InfoPubCoopNew.vue?vue&type=script&lang=js"
export * from "./InfoPubCoopNew.vue?vue&type=script&lang=js"
import style0 from "./InfoPubCoopNew.vue?vue&type=style&index=0&id=cd8cdf7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8cdf7e",
  null
  
)

export default component.exports